import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';

@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  constructor(private http: HttpClient) { 
  }

  savequotation(model: any) {
    model.idClient = Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID));
    return this.http.post(environment.apiUrl + 'Quotation/SaveQuotation', model);
  }
 
  recentquotation():Observable<any>{
    return  this.http.get(environment.apiUrl + 'Quotation/GetRecentquotation?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));

  }

  updarequotation(model: any) {
    return this.http.post(environment.apiUrl + 'Quotation/UpdateQuotation', model);
  }

  getall():Observable<any>{
    return  this.http.get(environment.apiUrl + 'Quotation/GetAllQuotation?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));

  }

  getallItem():Observable<any>{
    return  this.http.get(environment.apiUrl + 'Quotation/GetQuotationItems?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));

  }

  getbyidQuotation(id){
    return  this.http.get(environment.apiUrl + 'Quotation/GetQuotationById?id=' +id);
  }
  
  delete(id: any) {
    return this.http.delete(environment.apiUrl+'Quotation/Delete?id='+id);
  }
 
}
